import { z } from 'zod';
import { SchemaYear, ZodArrayToEnum } from '@axiom/types';
import { EducationDegreesKeys } from '@axiom/validation';

export const EducationFormSchema = z.object({
  lawSchoolId: z.string().uuid(),
  educationId: z.string().uuid().nullish(),
  candidateId: z.string().uuid(),
  degree: z.enum(ZodArrayToEnum(EducationDegreesKeys)),
  yearAwarded: SchemaYear,
});

export type EducationForm = z.infer<typeof EducationFormSchema>;
